module.exports = __webpack_public_path__ + "img/Analytics_PNG.b27d0f4a.png";